import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, AlertTitle } from '@mui/material';
import {
  Dialog,
  TextColor,
  ButtonColors,
  ThemeContext,
  StandardButton,
  ActionQueueType,
  ButtonStyleTypes,
} from '@gv/triage-components';

import { setCallFlowInProgress } from 'store/slices/analytics-export';

import { HangUpProps } from './types';
import {
  icon,
  text,
  title,
  completeText,
  completeAndSubmitText,
} from './config';

export const HangUpDialog = ({
  task,
  setOpen,
  onHangUp,
  ...props
}: HangUpProps) => {
  const { type, c_name } = task;
  const { isDarkTheme } = useContext(ThemeContext);
  const dispatch = useDispatch();

  const getTextElement = (): JSX.Element => {
    const clientName = c_name ? (
      <>
        {' '}
        for <span className="semibold">{c_name}</span>
      </>
    ) : (
      ''
    );

    return (
      <>
        {text[type]}
        {clientName}?
      </>
    );
  };

  return (
    <Dialog
      icon={icon[type]}
      title={title[type]}
      text={getTextElement()}
      iconColor={TextColor.Green}
      buttons={(close) => (
        <>
          <StandardButton
            fullWidth
            text={completeText[type]}
            colorType={ButtonColors.Primary}
            onClick={() => {
              close();
              setOpen(false);
              onHangUp(false);
            }}
          />

          <StandardButton
            fullWidth
            text={completeAndSubmitText[type]}
            colorType={
              type === ActionQueueType.Voice
                ? ButtonColors.Secondary
                : ButtonColors.Primary
            }
            onClick={() => {
              close();
              setOpen(false);
              onHangUp(true);
              localStorage.setItem('callFlowInProgress', 'false');
              dispatch(setCallFlowInProgress(false));
            }}
          />

          <StandardButton
            fullWidth
            text="Cancel"
            colorType={ButtonColors.Primary}
            styleType={ButtonStyleTypes.Outline}
            onClick={() => {
              close();
              setOpen(false);
            }}
          />
          {type !== ActionQueueType.Voice && type !== ActionQueueType.Video && (
            <Alert
              severity="error"
              variant="outlined"
              sx={{
                borderRadius: '8px',
                color: isDarkTheme ? '#F9F9F9' : '#d32f2f',
                bgcolor: isDarkTheme ? 'rgb(62, 43, 43)' : 'background.paper',
                border: isDarkTheme
                  ? '1px solid rgb(200, 32, 32)'
                  : '1px solid #d32f2f',
                '& .MuiAlert-icon': {
                  color: isDarkTheme ? 'rgb(200, 32, 32)' : '#d32f2f',
                },
              }}
            >
              <AlertTitle>Note</AlertTitle>
              You must enter all required information and submit the case before
              ending the chat.
            </Alert>
          )}
        </>
      )}
      {...props}
    />
  );
};
